export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5147.cd34fa21.jpg";